export default class WidgetConfig {
}
